import type { MultilingualQuestion } from '../../types/multilingualQuestion';

// Multilingual version of Mandatory Signs questions
export const mandatorySignsMultilingual: MultilingualQuestion[] = [
  {
    id: 'q-mand-sign-1',
    text: {
      en: 'Identify the road sign:',
      nl: 'Identificeer het verkeersbord:',
      ar: 'حدد علامة الطريق:'
    },
    options: [
      {
        id: 'q-mand-sign-1o1',
        text: {
          en: 'No entry for bicycles',
          nl: 'Geen toegang voor fietsen',
          ar: 'ممنوع الدخول للدراجات'
        }
      },
      {
        id: 'q-mand-sign-1o2',
        text: {
          en: 'End of the path for cyclists and mopeds',
          nl: 'Einde van het pad voor fietsers en bromfietsen',
          ar: 'نهاية المسار لراكبي الدراجات والدراجات البخارية'
        }
      },
      {
        id: 'q-mand-sign-1o3',
        text: {
          en: 'Bicycle parking area',
          nl: 'Fietsenstalling',
          ar: 'منطقة وقوف الدراجات'
        }
      }
    ],
    correctAnswerId: 'q-mand-sign-1o2',
    explanation: {
      en: 'This sign indicates the end of the mandatory path for cyclists and mopeds. After this sign, cyclists and moped riders are no longer required to use a designated path.',
      nl: 'Dit bord geeft het einde aan van het verplichte pad voor fietsers en bromfietsen. Na dit bord zijn fietsers en bromfietsers niet meer verplicht om een aangewezen pad te gebruiken.',
      ar: 'تشير هذه العلامة إلى نهاية المسار الإلزامي لراكبي الدراجات والدراجات البخارية. بعد هذه العلامة، لم يعد راكبو الدراجات والدراجات البخارية مطالبين باستخدام مسار محدد.'
    },
    subject: 'Mandatory Signs',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/signs/mandatory/q-mand-sign-1.jpg',
    imageHint: 'end of path for cyclists and mopeds'
  },
  {
    id: 'q-mand-sign-2',
    text: {
      en: 'Identify the road sign:',
      nl: 'Identificeer het verkeersbord:',
      ar: 'حدد علامة الطريق:'
    },
    options: [
      {
        id: 'q-mand-sign-2o1',
        text: {
          en: 'Mandatory lane for tractors',
          nl: 'Verplichte rijstrook voor tractoren',
          ar: 'ممر إلزامي للجرارات'
        }
      },
      {
        id: 'q-mand-sign-2o2',
        text: {
          en: 'Agricultural vehicles route',
          nl: 'Route voor landbouwvoertuigen',
          ar: 'مسار المركبات الزراعية'
        }
      },
      {
        id: 'q-mand-sign-2o3',
        text: {
          en: 'Tractors must use this route',
          nl: 'Tractoren moeten deze route gebruiken',
          ar: 'يجب على الجرارات استخدام هذا المسار'
        }
      }
    ],
    correctAnswerId: 'q-mand-sign-2o1',
    explanation: {
      en: 'This blue circular sign with a tractor symbol indicates a mandatory lane that must be used by tractors and agricultural vehicles.',
      nl: 'Dit blauwe ronde bord met een tractorsymbool geeft een verplichte rijstrook aan die moet worden gebruikt door tractoren en landbouwvoertuigen.',
      ar: 'تشير هذه العلامة الدائرية الزرقاء مع رمز الجرار إلى ممر إلزامي يجب أن يستخدمه الجرارات والمركبات الزراعية.'
    },
    subject: 'Mandatory Signs',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/signs/mandatory/q-mand-sign-2.jpg',
    imageHint: 'mandatory lane for tractors'
  },
  {
    id: 'q-mand-sign-3',
    text: {
      en: 'Identify the road sign:',
      nl: 'Identificeer het verkeersbord:',
      ar: 'حدد علامة الطريق:'
    },
    options: [
      {
        id: 'q-mand-sign-3o1',
        text: {
          en: 'Roundabout ahead',
          nl: 'Rotonde vooruit',
          ar: 'دوار أمامك'
        }
      },
      {
        id: 'q-mand-sign-3o2',
        text: {
          en: 'Direction of traffic on roundabout',
          nl: 'Richting van verkeer op rotonde',
          ar: 'اتجاه المرور في الدوار'
        }
      },
      {
        id: 'q-mand-sign-3o3',
        text: {
          en: 'Turn left or right',
          nl: 'Links of rechts afslaan',
          ar: 'انعطف يسارا أو يمينا'
        }
      }
    ],
    correctAnswerId: 'q-mand-sign-3o2',
    explanation: {
      en: 'This blue circular sign with arrows indicates the mandatory direction of traffic on a roundabout. Traffic must circulate in the direction shown by the arrows (typically counter-clockwise in the Netherlands).',
      nl: 'Dit blauwe ronde bord met pijlen geeft de verplichte richting van verkeer op een rotonde aan. Verkeer moet circuleren in de richting die door de pijlen wordt aangegeven (meestal tegen de klok in in Nederland).',
      ar: 'تشير هذه العلامة الدائرية الزرقاء مع الأسهم إلى الاتجاه الإلزامي للمرور في الدوار. يجب أن يدور المرور في الاتجاه الموضح بالأسهم (عادة عكس اتجاه عقارب الساعة في هولندا).'
    },
    subject: 'Mandatory Signs',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/signs/mandatory/q-mand-sign-3.jpg',
    imageHint: 'direction of traffic on roundabout'
  },
  {
    id: 'q-mand-sign-4',
    text: {
      en: 'Identify the road sign:',
      nl: 'Identificeer het verkeersbord:',
      ar: 'حدد علامة الطريق:'
    },
    options: [
      {
        id: 'q-mand-sign-4o1',
        text: {
          en: 'No entry for trams',
          nl: 'Geen toegang voor trams',
          ar: 'ممنوع الدخول للترام'
        }
      },
      {
        id: 'q-mand-sign-4o2',
        text: {
          en: 'End of the lane for trams',
          nl: 'Einde van de rijstrook voor trams',
          ar: 'نهاية الممر للترام'
        }
      },
      {
        id: 'q-mand-sign-4o3',
        text: {
          en: 'Tram stop ahead',
          nl: 'Tramhalte vooruit',
          ar: 'محطة ترام أمامك'
        }
      }
    ],
    correctAnswerId: 'q-mand-sign-4o2',
    explanation: {
      en: 'This sign indicates the end of the mandatory lane for trams. After this sign, trams are no longer required to use a designated lane.',
      nl: 'Dit bord geeft het einde aan van de verplichte rijstrook voor trams. Na dit bord zijn trams niet meer verplicht om een aangewezen rijstrook te gebruiken.',
      ar: 'تشير هذه العلامة إلى نهاية الممر الإلزامي للترام. بعد هذه العلامة، لم يعد الترام مطالبا باستخدام ممر محدد.'
    },
    subject: 'Mandatory Signs',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/signs/mandatory/q-mand-sign-4.jpg',
    imageHint: 'end of lane for trams'
  },
  {
    id: 'q-mand-sign-5',
    text: {
      en: 'Identify the road sign:',
      nl: 'Identificeer het verkeersbord:',
      ar: 'حدد علامة الطريق:'
    },
    options: [
      {
        id: 'q-mand-sign-5o1',
        text: {
          en: 'Turning right compulsory',
          nl: 'Rechtsaf slaan verplicht',
          ar: 'الانعطاف يمينا إلزامي'
        }
      },
      {
        id: 'q-mand-sign-5o2',
        text: {
          en: 'No right turn',
          nl: 'Geen rechtsaf',
          ar: 'ممنوع الانعطاف يمينا'
        }
      },
      {
        id: 'q-mand-sign-5o3',
        text: {
          en: 'Road bends right',
          nl: 'Weg buigt naar rechts',
          ar: 'الطريق ينحني يمينا'
        }
      }
    ],
    correctAnswerId: 'q-mand-sign-5o1',
    explanation: {
      en: 'This blue circular sign with a white arrow pointing right indicates that turning right is compulsory. Drivers must turn right.',
      nl: 'Dit blauwe ronde bord met een witte pijl naar rechts geeft aan dat rechtsaf slaan verplicht is. Bestuurders moeten rechtsaf slaan.',
      ar: 'تشير هذه العلامة الدائرية الزرقاء مع سهم أبيض يشير إلى اليمين إلى أن الانعطاف يمينا إلزامي. يجب على السائقين الانعطاف يمينا.'
    },
    subject: 'Mandatory Signs',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/signs/mandatory/q-mand-sign-5.jpg',
    imageHint: 'turning right compulsory'
  },
  {
    id: 'q-mand-sign-6',
    text: {
      en: 'Identify the road sign:',
      nl: 'Identificeer het verkeersbord:',
      ar: 'حدد علامة الطريق:'
    },
    options: [
      {
        id: 'q-mand-sign-6o1',
        text: {
          en: 'Turning left or right mandatory',
          nl: 'Links of rechtsaf slaan verplicht',
          ar: 'الانعطاف يسارا أو يمينا إلزامي'
        }
      },
      {
        id: 'q-mand-sign-6o2',
        text: {
          en: 'Vehicles may choose left or right',
          nl: 'Voertuigen mogen links of rechts kiezen',
          ar: 'يمكن للمركبات اختيار اليسار أو اليمين'
        }
      },
      {
        id: 'q-mand-sign-6o3',
        text: {
          en: 'No vehicles allowed',
          nl: 'Geen voertuigen toegestaan',
          ar: 'لا توجد مركبات مسموحة'
        }
      }
    ],
    correctAnswerId: 'q-mand-sign-6o1',
    explanation: {
      en: 'This blue circular sign with branching arrows indicates that turning left or right is mandatory. Drivers must choose one of these directions.',
      nl: 'Dit blauwe ronde bord met vertakkende pijlen geeft aan dat links of rechtsaf slaan verplicht is. Bestuurders moeten een van deze richtingen kiezen.',
      ar: 'تشير هذه العلامة الدائرية الزرقاء مع الأسهم المتفرعة إلى أن الانعطاف يسارا أو يمينا إلزامي. يجب على السائقين اختيار أحد هذه الاتجاهات.'
    },
    subject: 'Mandatory Signs',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/signs/mandatory/q-mand-sign-6.jpg',
    imageHint: 'turning left or right mandatory'
  },
  {
    id: 'q-mand-sign-7',
    text: {
      en: 'Identify the road sign:',
      nl: 'Identificeer het verkeersbord:',
      ar: 'حدد علامة الطريق:'
    },
    options: [
      {
        id: 'q-mand-sign-7o1',
        text: {
          en: 'Compulsory direction ahead',
          nl: 'Verplichte richting vooruit',
          ar: 'اتجاه إلزامي أمامك'
        }
      },
      {
        id: 'q-mand-sign-7o2',
        text: {
          en: 'Compulsory direction right',
          nl: 'Verplichte richting rechts',
          ar: 'اتجاه إلزامي يمين'
        }
      },
      {
        id: 'q-mand-sign-7o3',
        text: {
          en: 'Pass on right only',
          nl: 'Alleen rechts passeren',
          ar: 'التجاوز من اليمين فقط'
        }
      }
    ],
    correctAnswerId: 'q-mand-sign-7o3',
    explanation: {
      en: 'This blue circular sign with a white arrow pointing right indicates that passing is only allowed on the right side. Drivers must pass other vehicles on the right.',
      nl: 'Dit blauwe ronde bord met een witte pijl naar rechts geeft aan dat passeren alleen aan de rechterkant is toegestaan. Bestuurders moeten andere voertuigen rechts passeren.',
      ar: 'تشير هذه العلامة الدائرية الزرقاء مع سهم أبيض يشير إلى اليمين إلى أن التجاوز مسموح فقط من الجانب الأيمن. يجب على السائقين تجاوز المركبات الأخرى من اليمين.'
    },
    subject: 'Mandatory Signs',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/signs/mandatory/q-mand-sign-7.jpg',
    imageHint: 'pass on right only'
  },
  {
    id: 'q-mand-sign-8',
    text: {
      en: 'Identify the road sign:',
      nl: 'Identificeer het verkeersbord:',
      ar: 'حدد علامة الطريق:'
    },
    options: [
      {
        id: 'q-mand-sign-8o1',
        text: {
          en: 'Bus stop ahead',
          nl: 'Bushalte vooruit',
          ar: 'محطة حافلة أمامك'
        }
      },
      {
        id: 'q-mand-sign-8o2',
        text: {
          en: 'No buses allowed',
          nl: 'Geen bussen toegestaan',
          ar: 'لا توجد حافلات مسموحة'
        }
      },
      {
        id: 'q-mand-sign-8o3',
        text: {
          en: 'Mandatory lane for trams',
          nl: 'Verplichte rijstrook voor trams',
          ar: 'ممر إلزامي للترام'
        }
      }
    ],
    correctAnswerId: 'q-mand-sign-8o3',
    explanation: {
      en: 'This blue circular sign with a tram symbol indicates a mandatory lane for trams. Trams must use this designated lane.',
      nl: 'Dit blauwe ronde bord met een tramsymbool geeft een verplichte rijstrook voor trams aan. Trams moeten deze aangewezen rijstrook gebruiken.',
      ar: 'تشير هذه العلامة الدائرية الزرقاء مع رمز الترام إلى ممر إلزامي للترام. يجب على الترام استخدام هذا الممر المحدد.'
    },
    subject: 'Mandatory Signs',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/signs/mandatory/q-mand-sign-8.jpg',
    imageHint: 'mandatory lane for trams'
  },
  {
    id: 'q-mand-sign-9',
    text: {
      en: 'Identify the road sign:',
      nl: 'Identificeer het verkeersbord:',
      ar: 'حدد علامة الطريق:'
    },
    options: [
      {
        id: 'q-mand-sign-9o1',
        text: {
          en: 'Compulsory direction ahead',
          nl: 'Verplichte richting vooruit',
          ar: 'اتجاه إلزامي أمامك'
        }
      },
      {
        id: 'q-mand-sign-9o2',
        text: {
          en: 'Compulsory direction right',
          nl: 'Verplichte richting rechts',
          ar: 'اتجاه إلزامي يمين'
        }
      },
      {
        id: 'q-mand-sign-9o3',
        text: {
          en: 'Driving straight ahead or turning right mandatory',
          nl: 'Rechtdoor rijden of rechtsaf slaan verplicht',
          ar: 'القيادة مباشرة أو الانعطاف يمينا إلزامي'
        }
      }
    ],
    correctAnswerId: 'q-mand-sign-9o3',
    explanation: {
      en: 'This blue circular sign with two arrows (one straight, one right) indicates that driving straight ahead or turning right is mandatory. Both directions are required options.',
      nl: 'Dit blauwe ronde bord met twee pijlen (een recht, een rechts) geeft aan dat rechtdoor rijden of rechtsaf slaan verplicht is. Beide richtingen zijn verplichte opties.',
      ar: 'تشير هذه العلامة الدائرية الزرقاء مع سهمين (واحد مستقيم، واحد يمين) إلى أن القيادة مباشرة أو الانعطاف يمينا إلزامي. كلا الاتجاهين خيارات مطلوبة.'
    },
    subject: 'Mandatory Signs',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/signs/mandatory/q-mand-sign-9.jpg',
    imageHint: 'driving straight ahead or turning right mandatory'
  },
  {
    id: 'q-mand-sign-10',
    text: {
      en: 'Identify the road sign:',
      nl: 'Identificeer het verkeersbord:',
      ar: 'حدد علامة الطريق:'
    },
    options: [
      {
        id: 'q-mand-sign-10o1',
        text: {
          en: 'Mandatory path for equestrians',
          nl: 'Verplicht pad voor ruiters',
          ar: 'مسار إلزامي لراكبي الخيل'
        }
      },
      {
        id: 'q-mand-sign-10o2',
        text: {
          en: 'Horse riders prohibited',
          nl: 'Ruiters verboden',
          ar: 'ممنوع ركوب الخيل'
        }
      },
      {
        id: 'q-mand-sign-10o3',
        text: {
          en: 'Horse crossing ahead',
          nl: 'Paardenoversteekplaats vooruit',
          ar: 'معبر الخيول أمامك'
        }
      }
    ],
    correctAnswerId: 'q-mand-sign-10o1',
    explanation: {
      en: 'This blue circular sign with a horse rider symbol indicates a mandatory path for equestrians. Horse riders must use this designated path.',
      nl: 'Dit blauwe ronde bord met een ruiter symbool geeft een verplicht pad voor ruiters aan. Ruiters moeten dit aangewezen pad gebruiken.',
      ar: 'تشير هذه العلامة الدائرية الزرقاء مع رمز راكب الخيل إلى مسار إلزامي لراكبي الخيل. يجب على راكبي الخيل استخدام هذا المسار المحدد.'
    },
    subject: 'Mandatory Signs',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/signs/mandatory/q-mand-sign-10.jpg',
    imageHint: 'mandatory path for equestrians'
  }
  ,
  {
    id: 'q-mand-sign-11',
    text: {
      en: 'What color is a mandatory instruction sign?',
      nl: 'Welke kleur heeft een verplicht verkeersteken?',
      ar: 'ما لون لافتة التعليمات الإلزامية؟'
    },
    options: [
      {
        id: 'q-mand-sign-11o1',
        text: {
          en: 'Red circle with white symbol',
          nl: 'Rode cirkel met wit symbool',
          ar: 'دائرة حمراء مع رمز أبيض'
        }
      },
      {
        id: 'q-mand-sign-11o2',
        text: {
          en: 'Blue rectangle with white symbol',
          nl: 'Blauwe rechthoek met wit symbool',
          ar: 'مستطيل أزرق مع رمز أبيض'
        }
      },
      {
        id: 'q-mand-sign-11o3',
        text: {
          en: 'Yellow triangle with red border',
          nl: 'Gele driehoek met rode rand',
          ar: 'مثلث أصفر مع إطار أحمر'
        }
      }
    ],
    correctAnswerId: 'q-mand-sign-11o2',
    explanation: {
      en: 'Mandatory instruction signs are blue rectangular signs with white symbols. These signs convey instructions and regulations that must be followed, such as mandatory lanes and directions.',
      nl: 'Verplichte verkeerstekens zijn blauwe rechthoekige borden met witte symbolen. Ze geven instructies en regels aan die je moet volgen, zoals verplichte rijstroken en richtingen.',
      ar: 'لافتات التعليمات الإلزامية تكون على شكل مستطيلات زرقاء مع رموز بيضاء. تنقل هذه اللافتات تعليمات وأنظمة يجب اتباعها، مثل الممرات الإلزامية والاتجاهات.'
    },
    subject: 'Mandatory Signs'
  },
  {
    id: 'q-mand-sign-12',
    text: {
      en: 'What does a blue arrow sign pointing straight ahead indicate?',
      nl: 'Wat betekent een blauw pijlbord dat recht vooruit wijst?',
      ar: 'ماذا تشير لافتة سهم زرقاء تشير للأمام مباشرة؟'
    },
    options: [
      {
        id: 'q-mand-sign-12o1',
        text: {
          en: 'Straight ahead is recommended',
          nl: 'Rechtdoor is aanbevolen',
          ar: 'يُنصح بالقيادة للأمام مباشرة'
        }
      },
      {
        id: 'q-mand-sign-12o2',
        text: {
          en: 'You must drive straight ahead',
          nl: 'Je moet rechtdoor rijden',
          ar: 'يجب عليك القيادة للأمام مباشرة'
        }
      },
      {
        id: 'q-mand-sign-12o3',
        text: {
          en: 'You may drive straight ahead',
          nl: 'Je mag rechtdoor rijden',
          ar: 'يجوز لك القيادة للأمام مباشرة'
        }
      }
    ],
    correctAnswerId: 'q-mand-sign-12o2',
    explanation: {
      en: 'A blue circle with a white arrow pointing straight ahead is a mandatory instruction sign indicating that you must proceed straight ahead. You cannot turn left or right at this location.',
      nl: 'Een blauwe cirkel met een witte pijl die recht vooruit wijst, is een verplicht verkeersteken dat aangeeft dat je rechtdoor moet. Je mag hier niet links of rechts afslaan.',
      ar: 'إن دائرة زرقاء مع سهم أبيض يشير إلى الأمام مباشرة هي علامة تعليمات إلزامية تُشير إلى أنه يجب أن تستمر للأمام مباشرة. لا يمكنك الانعطاف يساراً أو يميناً في هذا المكان.'
    },
    subject: 'Mandatory Signs'
  },
  {
    id: 'q-mand-sign-13',
    text: {
      en: 'What does a mandatory sign with a left arrow indicate?',
      nl: 'Wat betekent een verplicht bord met een pijl naar links?',
      ar: 'ماذا تشير لافتة إلزامية بسهم يسار؟'
    },
    options: [
      {
        id: 'q-mand-sign-13o1',
        text: {
          en: 'You must turn left at this location',
          nl: 'Je moet hier linksaf slaan',
          ar: 'يجب أن تنعطف يساراً عند هذا الموقع'
        }
      },
      {
        id: 'q-mand-sign-13o2',
        text: {
          en: 'Turning left is prohibited',
          nl: 'Linksaf slaan is verboden',
          ar: 'يحظر الانعطاف يساراً'
        }
      },
      {
        id: 'q-mand-sign-13o3',
        text: {
          en: 'You may turn left if safe',
          nl: 'Je mag linksaf slaan als het veilig is',
          ar: 'يجوز لك الانعطاف يساراً إذا كان ذلك آمناً'
        }
      }
    ],
    correctAnswerId: 'q-mand-sign-13o1',
    explanation: {
      en: 'A blue circular sign with a white arrow pointing left is a mandatory instruction requiring you to turn left. You must follow this instruction and cannot continue straight.',
      nl: 'Een blauw rond bord met een witte pijl naar links geeft een verplichting om linksaf te slaan. Je moet dit volgen en mag niet rechtdoor blijven rijden.',
      ar: 'إن اللافتة الدائرية الزرقاء مع سهم أبيض يشير إلى اليسار تعتبر تعليمات إلزامية تتطلب منك الانعطاف يساراً. يجب الالتزام بهذه التعليمة ولا يمكنك متابعة السير بشكل مستقيم.'
    },
    subject: 'Mandatory Signs'
  },
  {
    id: 'q-mand-sign-14',
    text: {
      en: 'What does a mandatory sign showing two arrows (left and right) indicate?',
      nl: 'Wat betekent een verplicht bord met twee pijlen (links en rechts)?',
      ar: 'ماذا تعني لافتة إلزامية تُظهر سهمين (يساراً ويميناً)؟'
    },
    options: [
      {
        id: 'q-mand-sign-14o1',
        text: {
          en: 'You must choose between turning left or right',
          nl: 'Je moet kiezen tussen links- en rechtsaf slaan',
          ar: 'يجب عليك اختيار الانعطاف يساراً أو يميناً'
        }
      },
      {
        id: 'q-mand-sign-14o2',
        text: {
          en: 'Both directions are equally recommended',
          nl: 'Beide richtingen zijn even aanbevolen',
          ar: 'الاتجاهان موصى بهما بالتساوي'
        }
      },
      {
        id: 'q-mand-sign-14o3',
        text: {
          en: 'You can continue straight',
          nl: 'Je kunt rechtdoor rijden',
          ar: 'يمكنك متابعة السير مستقيمًا'
        }
      }
    ],
    correctAnswerId: 'q-mand-sign-14o1',
    explanation: {
      en: 'A blue circular sign with two arrows (one pointing left, one pointing right) indicates that you must turn either left or right. You cannot continue straight.',
      nl: 'Een blauw rond bord met twee pijlen (één naar links, één naar rechts) betekent dat je ofwel links ofwel rechts moet afslaan. Je mag niet rechtdoor rijden.',
      ar: 'إن اللافتة الدائرية الزرقاء مع سهمين (واحد يشير إلى اليسار وواحد إلى اليمين) تعني أنه يجب أن تنعطف إما يساراً أو يميناً. لا يمكنك الاستمرار مستقيمًا.'
    },
    subject: 'Mandatory Signs'
  },
  {
    id: 'q-mand-sign-15',
    text: {
      en: 'What does a sign showing a bicycle symbol on a blue background indicate?',
      nl: 'Wat betekent een bord met een fietssymbool op een blauwe achtergrond?',
      ar: 'ماذا تشير لافتة تُظهر رمز دراجة على خلفية زرقاء؟'
    },
    options: [
      {
        id: 'q-mand-sign-15o1',
        text: {
          en: 'Bicycles are prohibited',
          nl: 'Fietsen zijn verboden',
          ar: 'ممنوع الدراجات'
        }
      },
      {
        id: 'q-mand-sign-15o2',
        text: {
          en: 'This is a mandatory bicycle path',
          nl: 'Dit is een verplichte fietspad',
          ar: 'هذا مسار دراجات إلزامي'
        }
      },
      {
        id: 'q-mand-sign-15o3',
        text: {
          en: 'Bicycle rental is available',
          nl: 'Fietsen zijn te huur',
          ar: 'تتوفر خدمة تأجير الدراجات'
        }
      }
    ],
    correctAnswerId: 'q-mand-sign-15o2',
    explanation: {
      en: 'A blue sign with a white bicycle symbol indicates a mandatory bicycle path. Cyclists must use this path, and it is reserved for bicycles and sometimes mopeds.',
      nl: 'Een blauw bord met een wit fietssymbool duidt op een verplicht fietspad. Fietsers moeten dit pad gebruiken; het is bestemd voor fietsen en soms voor bromfietsen.',
      ar: 'تشير اللافتة الزرقاء مع رمز دراجة أبيض إلى مسار دراجات إلزامي. يجب على راكبي الدراجات استخدام هذا المسار، وهو مخصص للدراجات وأحياناً للدراجات النارية الصغيرة.'
    },
    subject: 'Mandatory Signs'
  },
  {
    id: 'q-mand-sign-16',
    text: {
      en: 'What does a pedestrian crossing mandatory sign look like?',
      nl: 'Hoe ziet een verplicht oversteekbord voor voetgangers eruit?',
      ar: 'كيف تبدو علامة عبور المشاة الإلزامية؟'
    },
    options: [
      {
        id: 'q-mand-sign-16o1',
        text: {
          en: 'Blue rectangle with white pedestrian figure',
          nl: 'Blauwe rechthoek met wit voetgangersfiguur',
          ar: 'مستطيل أزرق مع شخصية مشاة بيضاء'
        }
      },
      {
        id: 'q-mand-sign-16o2',
        text: {
          en: 'Red circle with white pedestrian figure',
          nl: 'Rode cirkel met wit voetgangersfiguur',
          ar: 'دائرة حمراء مع شخصية مشاة بيضاء'
        }
      },
      {
        id: 'q-mand-sign-16o3',
        text: {
          en: 'White triangle with red border',
          nl: 'Witte driehoek met rode rand',
          ar: 'مثلث أبيض بإطار أحمر'
        }
      }
    ],
    correctAnswerId: 'q-mand-sign-16o1',
    explanation: {
      en: 'A blue rectangular sign with a white pedestrian figure indicates a mandatory pedestrian crossing. This marks an official crossing area where pedestrians must cross.',
      nl: 'Een blauw rechthoekig bord met een wit voetgangersfiguur geeft een verplichte oversteek voor voetgangers aan. Dit markeert een officiële oversteekplaats waar voetgangers moeten oversteken.',
      ar: 'تشير اللافتة المستطيلة الزرقاء مع شخصية مشاة بيضاء إلى عبور مشاة إلزامي. هذه تحدد منطقة عبور رسمية يجب على المشاة عبورها.'
    },
    subject: 'Mandatory Signs'
  },
  {
    id: 'q-mand-sign-17',
    text: {
      en: 'What is indicated by a blue lane marking sign with a car symbol?',
      nl: 'Wat geeft een blauw rijstrookbord met een autosymbool aan?',
      ar: 'ماذا تشير لافتة مسار زرقاء مع رمز سيارة؟'
    },
    options: [
      {
        id: 'q-mand-sign-17o1',
        text: {
          en: 'This lane is reserved for motor vehicles only',
          nl: 'Deze rijstrook is alleen voor motorvoertuigen bestemd',
          ar: 'هذا الممر مخصص للمركبات الآلية فقط'
        }
      },
      {
        id: 'q-mand-sign-17o2',
        text: {
          en: 'Motor vehicles are prohibited',
          nl: 'Motorvoertuigen zijn verboden',
          ar: 'ممنوع المركبات الآلية'
        }
      },
      {
        id: 'q-mand-sign-17o3',
        text: {
          en: 'Vehicles may park here',
          nl: 'Voertuigen mogen hier parkeren',
          ar: 'يمكن للمركبات الوقوف هنا'
        }
      }
    ],
    correctAnswerId: 'q-mand-sign-17o1',
    explanation: {
      en: 'A blue sign with a car symbol indicates a lane or road reserved for motor vehicles only. Other vehicles and road users cannot use this facility.',
      nl: 'Een blauw bord met een autosymbool geeft een rijstrook of weg aan die alleen voor motorvoertuigen is bestemd. Andere voertuigen en weggebruikers mogen hiervan geen gebruik maken.',
      ar: 'تشير اللافتة الزرقاء مع رمز سيارة إلى ممر أو طريق مخصص للمركبات الآلية فقط. لا يمكن لباقي المركبات أو مستخدمي الطريق استخدام هذا المرفق.'
    },
    subject: 'Mandatory Signs'
  },
  {
    id: 'q-mand-sign-18',
    text: {
      en: 'What does a minimum speed mandatory sign indicate?',
      nl: 'Wat betekent een verplicht minimumsnelheidsteken?',
      ar: 'ماذا تشير لافتة السرعة الدنيا الإلزامية؟'
    },
    options: [
      {
        id: 'q-mand-sign-18o1',
        text: {
          en: 'You must not exceed this speed',
          nl: 'Je mag deze snelheid niet overschrijden',
          ar: 'يجب ألا تتجاوز هذه السرعة'
        }
      },
      {
        id: 'q-mand-sign-18o2',
        text: {
          en: 'You must maintain at least this minimum speed',
          nl: 'Je moet minimaal deze snelheid aanhouden',
          ar: 'يجب أن تحافظ على الأقل على هذه السرعة الدنيا'
        }
      },
      {
        id: 'q-mand-sign-18o3',
        text: {
          en: 'This is the recommended speed',
          nl: 'Dit is de aanbevolen snelheid',
          ar: 'هذه هي السرعة الموصى بها'
        }
      }
    ],
    correctAnswerId: 'q-mand-sign-18o2',
    explanation: {
      en: 'A blue circular sign with numbers and an upward arrow indicates a mandatory minimum speed. You must drive at least at this speed, except when conditions make it unsafe.',
      nl: 'Een blauw rond bord met cijfers en een pijl omhoog geeft een verplichte minimumsnelheid aan. Je moet minstens met deze snelheid rijden, behalve als omstandigheden het onveilig maken.',
      ar: 'تشير اللافتة الدائرية الزرقاء بالأرقام وسهم للأعلى إلى سرعة دنيا إلزامية. يجب أن تقود بسرعة لا تقل عن هذه السرعة، إلا عندما تجعل الظروف ذلك غير آمن.'
    },
    subject: 'Mandatory Signs'
  },
  {
    id: 'q-mand-sign-19',
    text: {
      en: 'What does a sign showing a bus symbol on a blue background indicate?',
      nl: 'Wat betekent een bord met een busschimbool op een blauwe achtergrond?',
      ar: 'ماذا تشير لافتة تُظهر رمز حافلة على خلفية زرقاء؟'
    },
    options: [
      {
        id: 'q-mand-sign-19o1',
        text: {
          en: 'Buses are prohibited',
          nl: 'Bussen zijn verboden',
          ar: 'ممنوع الحافلات'
        }
      },
      {
        id: 'q-mand-sign-19o2',
        text: {
          en: 'This is a mandatory bus lane',
          nl: 'Dit is een verplichte busstrook',
          ar: 'هذا ممر حافلات إلزامي'
        }
      },
      {
        id: 'q-mand-sign-19o3',
        text: {
          en: 'A bus stop is ahead',
          nl: 'Er is een bushalte verderop',
          ar: 'توجد محطة حافلات أمامك'
        }
      }
    ],
    correctAnswerId: 'q-mand-sign-19o2',
    explanation: {
      en: 'A blue sign with a white bus symbol indicates a mandatory bus lane. Only buses are permitted to use this lane during specified times.',
      nl: 'Een blauw bord met een wit busschimbool geeft een verplichte busstrook aan. Alleen bussen mogen deze strook gebruiken tijdens de aangegeven tijden.',
      ar: 'تشير اللافتة الزرقاء مع رمز حافلة أبيض إلى ممر حافلات إلزامي. يُسمح باستخدام هذا الممر للحافلات فقط خلال الأوقات المحددة.'
    },
    subject: 'Mandatory Signs'
  },
  {
    id: 'q-mand-sign-20',
    text: {
      en: 'What is the purpose of mandatory signs in traffic?',
      nl: 'Wat is het doel van verplichte borden in het verkeer?',
      ar: 'ما الغرض من اللافتات الإلزامية في المرور؟'
    },
    options: [
      {
        id: 'q-mand-sign-20o1',
        text: {
          en: 'To give advice and recommendations',
          nl: 'Om advies en aanbevelingen te geven',
          ar: 'لتقديم نصائح وتوصيات'
        }
      },
      {
        id: 'q-mand-sign-20o2',
        text: {
          en: 'To convey orders and instructions that must be obeyed',
          nl: 'Om bevelen en instructies door te geven die je moet opvolgen',
          ar: 'لنقل أوامر وتعليمات يجب اتباعها'
        }
      },
      {
        id: 'q-mand-sign-20o3',
        text: {
          en: 'To warn of potential hazards',
          nl: 'Om te waarschuwen voor mogelijke gevaren',
          ar: 'لتحذير من مخاطر محتملة'
        }
      }
    ],
    correctAnswerId: 'q-mand-sign-20o2',
    explanation: {
      en: 'Mandatory signs convey orders and instructions that all road users must obey. Failing to follow a mandatory sign can result in fines or penalties.',
      nl: 'Verplichte borden geven bevelen en instructies die alle weggebruikers moeten volgen. Als je een verplicht bord niet opvolgt, kan dat leiden tot boetes of sancties.',
      ar: 'تنقل اللافتات الإلزامية أوامر وتعليمات يجب على جميع مستخدمي الطريق اتباعها. عدم الالتزام باللافتة الإلزامية قد يؤدي إلى غرامات أو عقوبات.'
    },
    subject: 'Mandatory Signs'
  }
];

























